import React from 'react';

function SteepConnector(props: React.HTMLAttributes<HTMLDivElement>): React.JSX.Element {
    return (
        <div {...props}>
            <svg
                id="eGMXKoT0wWE1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 72 49"
                shapeRendering="geometricPrecision"
                textRendering="geometricPrecision"
            >
                <path
                    d="M1,21.5h11.1195c4.7643,0,9.4601,1.1347,13.6987,3.3102L71,48"
                    fill="none"
                    stroke="#cadbe8"
                    strokeLinecap="round"
                />
            </svg>
        </div>
    );
}

export default SteepConnector;
